var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3489 4.12109H8.73445C6.45128 4.12109 5.30969 4.12109 4.6004 4.82015C3.89111 5.5192 3.89111 6.6443 3.89111 8.89452V12.8724C3.89111 15.1226 3.89111 16.2477 4.6004 16.9467C5.30969 17.6458 6.45128 17.6458 8.73445 17.6458H9.81863C10.4785 17.6458 10.8085 17.6458 11.1052 17.5247C11.4019 17.4035 11.6352 17.1736 12.1019 16.7137L14.2465 14.6C14.7131 14.1401 14.9464 13.9102 15.0694 13.6177C15.1922 13.3254 15.1922 13.0001 15.1922 12.3498V8.89452C15.1922 6.6443 15.1922 5.5192 14.4829 4.82015C13.7736 4.12109 12.632 4.12109 10.3489 4.12109Z",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7524 17.2474V16.4518C10.7524 14.9517 10.7524 14.2016 11.2253 13.7356C11.6982 13.2695 12.4592 13.2695 13.9813 13.2695H14.7886",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89115 15.2591C2.5537 15.2591 1.46948 14.1905 1.46948 12.8724V6.5078C1.46948 4.25758 1.46948 3.13248 2.17877 2.43343C2.88806 1.73438 4.02964 1.73438 6.31282 1.73438H10.3493C11.6867 1.73438 12.7709 2.80298 12.7709 4.12111",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71753 10.485H9.94642M6.71753 7.30273H12.3681",
    stroke: "#818183",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.b70f23166ee2916b36bd4e0114b5f709.svg";
export { ForwardRef as ReactComponent };